/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./TextWidgetTypesUpgradeHelper',
	'./ConditionalPaletteUpgradeHelper',
	'./SinglePageDashboardsUpgradeHelper'
], function (_, Class, UpgradeBase, textWidgetTypesUpgradeHelper, conditionalPaletteUpgradeHelper, singlePageDashboardsUpgradeHelper) {

	/**
	* Upgrade old depricated text widget classes to the standard font/size classes. Remove these classes and definitions from the themes and stylesheets.
	* Upgrade conditionalPalette: In the R releases we saved the actual hex values in the conditional format part of the widget spec. On upgrade, we now match those hex values to one of our system CondtionalPalettes to get the palette name and set the widget property accordingly.
	* Upgrade existing single page dashboards to tabbed dashboards with the tabs hidden.
	**/

	var Upgrade = Class.extend([UpgradeBase], {
		init: function() {
			this.VERSION = 1010;
			this.textWidgetTypesUpgradeHelper = new textWidgetTypesUpgradeHelper();
			this.conditionalPaletteUpgradeHelper = new conditionalPaletteUpgradeHelper();
			this.singlePageDashboardsUpgradeHelper = new singlePageDashboardsUpgradeHelper();
		},

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up: function(spec) {
			this.dashboardApi = this.data.dashboardApi;
			return this.textWidgetTypesUpgradeHelper.upgrade(spec).then((spec) => {
				return this.conditionalPaletteUpgradeHelper.upgrade(spec,this.dashboardApi);
			}).then((spec) => {
				return this.singlePageDashboardsUpgradeHelper.upgrade(spec);
			});
		},

		down: function(spec) {
			// no downgrade at this time; return as is
			return Promise.resolve(spec);
		}

	});

	return new Upgrade();
});
